import React,{Component,PropTypes} from 'react';
import ReactDOM from 'react-dom';

import './index.css';


import CommentInput from './CommentInput'
import CommentList from './CommentList'

class CommentApp  extends Component{
  constructor () {
      super()
      this.state = {
        comments: []
      }
    }

    handleSubmitComment (comment) {
      if (!comment) return
      if (!comment.username) return alert('请输入用户名')
      if (!comment.content) return alert('请输入评论内容')
      this.state.comments.push(comment)
      this.setState({
        comments: this.state.comments
      });
      this._saveComments(this.state.comments);
    }

    _saveComments(comments){
      localStorage.setItem('comments',JSON.stringify(comments))
    }

    componentWillMount(){
      let comments = localStorage.getItem('comments');
      if(comments){
        comments = JSON.parse(comments);
        this.setState({comments});
      }
    }

    handleDeleteComment(index){
      const comments = this.state.comments
      comments.splice(index, 1)
      this.setState({ comments })
      this._saveComments(comments)
    }

    render(){
      return(
        <div className='wrapper'>
          <CommentInput onSubmit={this.handleSubmitComment.bind(this)} />
          <CommentList comments={this.state.comments}  onDeleteComment={this.handleDeleteComment.bind(this)} />
        </div>
      )
    }
}


//组件的挂载：React.js将组件渲染，并且构造DOM元素然后塞入页面的过程称为组件的挂载

//在React.js中完整的过程是这样：
/*
-->constructor()
-->componentWillMount()
-->render()
//构造DOM元素插入页面
-->componentDidMount()
//...
//即将从页面中删除
-->componentWillUnmount()
//从页面删除
*/


//组件的更新阶段
/*
shouldComponentUpdata(nextProps,nextState):控制组件是否重新渲染.false组件不会重新渲染。用于性能优化
componentWillReceiveProps(nextProps):组件从父组件接收到新的props之前
componentWillUpdata():组件开始重新渲染之前
componentDidUpdate():组件重新渲染并更改到真实DOM以后引用
*/


//大神文章Virtual DOM 算法https://github.com/livoras/blog/issues/13

class Header extends Component{
  constructor(){
    super()
    this.state = {
      date:new Date()
    }
  }

  componentWillMount(){
    this.timer = setInterval(()=>{
      this.setState({date:new Date()})
    },1000)
  }

  componentWillUnmount(){
    clearInterval(this.timer);
  }

  render(){
    return(
      <div>
        <h1>
          <p>现在的时间是</p>
          {this.state.date.toLocaleTimeString()}
        </h1>
      </div>
    )
  }
}


class Index extends Component{
  constructor(){
    super()
    this.state = {
      isShowClock : true
    }
  }
  render(){
    return (
      <div>
        {this.state.isShowClock ? <Header /> : null}
        <button onClick={()=>{this.setState({isShowClock:!this.state.isShowClock})}}>显示或隐藏</button>
      </div>
    )
  }
}

class AutoFocusInput extends Component{
  componentDidMount(){
    //this.input.focus();
    this.refs.text.focus();         //this.refs.[refName] 就会返回这个真实的 DOM 节点。
  }
  render(){
    return (
      //<input ref={(input)=>this.input = input} />
      <input ref="text" />        //有时需要从组件获取真实 DOM 的节点，这时就要用到 ref 属性
    )
  }
}

class Card extends Component {
  render(){
    return(
      <div>
        {this.props.children[0]}
      </div>
    )
  }
}


class Editor extends Component {
  constructor(){
    super();
    this.state = {
      content : '<h1>人生几何 能够得到只鸡</h1>'      //React.js的转义特性，
    }
  }
  //如何展示动态的效果呢？需要给 dangerouslySetInnerHTML 传入一个对象，这个对象的 __html 属性值就相当于元素的 innerHTML
  render(){
    return(
      <div className="editor-wrapper" dangerouslySetInnerHTML={{__html:this.state.content}}></div>
    )
  }
}

//https://facebook.github.io/react/docs/typechecking-with-proptypes.html

class Comment extends Component {
  static propTypes = {
    comment : PropTypes.object,         //必须是object
    test:PropTypes.object.isRequired    //再强调组件参数必须传入
  }

  render(){
    const {comment} = this.props;
    return(
      <div>
        <div>
          <span>{comment.username}</span>
        </div>
        <p>{comment.content}</p>
      </div>
    )
  }
}

ReactDOM.render(
  // <Comment comment={1} />
  <CommentApp />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js